"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//

var IFRAME_SRC = 'http://localhost:8080/h5-admin/index.html';
var _default = exports.default = {
  name: 'ReceiptPrintConfig',
  data: function data() {
    return {
      iframeSrc: IFRAME_SRC
    };
  },
  mounted: function mounted() {
    this.updateHeight();
    window.addEventListener('resize', this.updateHeight);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.updateHeight);
  },
  methods: {
    updateHeight: function updateHeight() {
      var container = this.$refs.container;
      if (!container) return;
      var top = container.getBoundingClientRect().top;
      container.style.height = "".concat(window.innerHeight - top, "px");
    }
  }
};